export const IA_ERROR_REQUEST_TYPE = {
  400: 'ia_generic_error',
  503: 'ia_service_unavailable_error',
  500: 'ia_external_service_error',
  429: 'ia_rate_limit_error',
};